export default __webpack_public_path__ + "static/media/Quote 1.ad0d60ee.png";